"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-6a91e0ef"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = { class: "home-analysis-dashboard-item home-view-box" };
const _hoisted_2 = { class: "home-analysis-dashboard-item-content" };
const _hoisted_3 = { class: "home-analysis-dashboard-item-name local-main-color-secondary-text" };
const _hoisted_4 = { class: "home-analysis-dashboard-item-rate" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_1.createElementVNode)("div", { class: "home-analysis-dashboard-item-rate-name local-main-color-secondary-text" }, "逾期率（T+1）", -1));
const _hoisted_6 = { class: "home-analysis-dashboard-item-rate-data" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HomeIcon = (0, vue_1.resolveComponent)("HomeIcon");
    const _component_NumberChange = (0, vue_1.resolveComponent)("NumberChange");
    const _component_NumberArea = (0, vue_1.resolveComponent)("NumberArea");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createVNode)(_component_HomeIcon, {
            name: 'module',
            rgb: _ctx.rgb
        }, null, 8, ["rgb"]),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, (0, vue_1.toDisplayString)(_ctx.name), 1),
            (0, vue_1.createElementVNode)("div", {
                class: "home-analysis-dashboard-item-data",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.toList && _ctx.toList(...args)))
            }, [
                (0, vue_1.createVNode)(_component_NumberChange, { data: _ctx.num }, null, 8, ["data"])
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                _hoisted_5,
                (0, vue_1.createElementVNode)("div", _hoisted_6, [
                    (0, vue_1.createVNode)(_component_NumberArea, {
                        data: _ctx.rate,
                        decimal: 2,
                        comma: '',
                        unit: '%'
                    }, null, 8, ["data"])
                ])
            ])
        ])
    ]));
}
exports.render = render;
